import { Link } from 'react-router';
import { useFishing } from '../lib/gold';
import { formatMoney } from '../lib/money';
import { EmptyState, Panel } from './ui';

/** A Book page's fishing (M15): skill, catches and where, from the Gold section's numbers. */
export function FishingPanel({ characterId, name }: { characterId: string; name: string }) {
  const q = useFishing();
  const c = q.data?.characters.find((x) => x.characterId === characterId);
  return (
    <Panel
      title="Fishing"
      level="side"
      meta={c?.rank != null ? `${c.rank}/${c.max ?? '—'}` : undefined}
    >
      {!q.data ? (
        <EmptyState>{q.isError ? 'Couldn’t load it.' : 'Loading…'}</EmptyState>
      ) : !c ? (
        <EmptyState>{name} doesn’t fish yet.</EmptyState>
      ) : c.catches === 0 ? (
        <EmptyState>
          No catches recorded yet — they’re counted from the Brimstone addon 0.4.0 on.
        </EmptyState>
      ) : (
        <>
          <ul className="m-0 list-none px-4 py-2 text-compact">
            {c.zones.slice(0, 4).map((z) => (
              <li
                key={z.zone}
                className="flex flex-col border-b border-line-soft py-1.5 last:border-b-0"
              >
                <span className="flex justify-between gap-3">
                  <span>{z.zone}</span>
                  <span className="font-mono text-muted">
                    {z.catches} · {formatMoney(z.valueCopper, true)}
                  </span>
                </span>
                <span className="truncate text-secondary text-muted">
                  {z.top.map((t) => `${t.name ?? `Item ${t.itemId}`} ×${t.count}`).join(', ')}
                </span>
              </li>
            ))}
          </ul>
          <p className="m-0 border-t border-line px-4 py-3 text-compact">
            <Link to="/gold?view=fishing">Fishing on the Gold page</Link>
          </p>
        </>
      )}
    </Panel>
  );
}
